function HorizTabs(el) {
  this.elems = {};
  this.elems.root = $(el);
  this.elems.tabs = this.elems.root.find('[data-horiz-tab]');
  this.elems.targets = this.elems.root.find('[data-horiz-target]');
  this.elems.selector = this.elems.root.find('.horiz-content-tabs-selector');

  this.bind();
  $(this.elems.tabs[0]).click();
}

HorizTabs.prototype.bind = function() {
  let self = this;
  this.elems.tabs.each(function() {
    let elTab = $(this);
    let targetName = elTab.attr('data-horiz-tab');
    elTab.click(() => {
      self.elems.tabs.removeClass('active');
      self.elems.targets.hide();
      elTab.addClass('active');
      self.elems.root.find('[data-horiz-target="' + targetName + '"]').fadeIn(500);
      self.moveSelectorToTab(elTab);
    });
  });
};

HorizTabs.prototype.moveSelectorToTab = function(elTab) {
  window.elTab = elTab;
  TweenMax.to(this.elems.selector, .3, {
    width: elTab.width() + 6,
    left: elTab.offset().left - this.elems.root.offset().left + 1,
  });
};

export default {
  start() {
    $('[data-horiz-tabs]').each(function() {
      new HorizTabs(this);
    });
  }
}